import React from "react"

const NotFound = ({ message }) => (
  <h1 style={{ marginLeft: "10%" }}>404 Not Found {message}</h1>
)

export default NotFound
